import React from "react";
import styled from "styled-components";
import { DEFAULT_PROJECT_PALETTE, PROJECT_PALETTES } from "@lifeat/shared/projects/ProjectsConstants";
import { Project } from "@lifeat/shared/projects/ProjectsTypes";
import { useAppearanceContext } from "@contexts/AppearanceContext";
import { FontSize } from "@themes/Fonts";
import { blendHexColors } from "@util/StyleUtil";

const Container = styled.div<{ hoverColor: string; disableHover: boolean; fontSize?: string }>`
    display: flex;
    align-items: center;
    width: fit-content;
    max-width: 150px;
    height: fit-content;
    padding: 2px 4px;
    font-size: ${(props) => props.fontSize ?? FontSize.small};
    border-radius: 2px;
    gap: 5px;
    cursor: pointer;
    overflow: hidden;
`;

const Title = styled.span<{ textColor: string }>`
    color: ${(props) => props.textColor};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

type ProjectChipProps = {
    project: Project;
    disableHover?: boolean;
    fontSizeCss?: string;
    className?: string;
};

export default function ProjectChip(props: ProjectChipProps) {
    const { lightMode } = useAppearanceContext();
    const palette = PROJECT_PALETTES.find((c) => c.primary === props.project.color) ?? DEFAULT_PROJECT_PALETTE;
    const backgroundColor = lightMode ? palette.lighter : palette.darker;
    const textColor = lightMode ? palette.darker : palette.lighter;
    const hoverColor = blendHexColors(backgroundColor, textColor, 0.8);

    return (
        <Container
            className={props.className}
            hoverColor={hoverColor}
            disableHover={!!props.disableHover}
            fontSize={props.fontSizeCss}
        >
            <Title textColor={textColor}>#{props.project.title}</Title>
        </Container>
    );
}
